import React from "react";
import img from '../../../assets/images/01.png'
import img1 from '../../../assets/images/02.png'
import img2 from '../../../assets/images/03.png'

const MethodHome = () => {

    return (
        <div className="methods grid3 reveal">
            <div className="method-item reveal_1">
                <div className="method-head"><img src={img} alt="" /></div>
                <div className="method-body">
                    <h1 className="method-title">Analyse & Recherche</h1>
                    <p className="method-para">Nous commençons par la recherche aussi pour imager les mers vides grand jour mer ne créature pas.</p>
                </div>
            </div>
            <div className="method-item reveal_2">
                <div className="method-head"><img src={img1} alt="" /></div>
                <div className="method-body">
                    <h1 className="method-title">Développement</h1>
                    <p className="method-para">Dans cette étape, nous vous soumettons à la vie craeted jour donné la lumière gethering.</p>
                </div>
            </div>
            <div className="method-item reveal_3">
                <div className="method-head"><img src={img2} alt="" /></div>
                <div className="method-body">
                    <h1 className="method-title">Tests & Verifications</h1>
                    <p className="methodd-para">Dernière étape du succès firmament de aussiit grand ont fixé la terre troisième.</p>
                </div>
            </div>
        </div>
    )
}

export default MethodHome